import { FixAssetLookupUnitModel } from "./fix-asset-lookup-unit.model";

export class FixAssetLookupOrganizationModel {
    id: string;
    name: string;
    code: string;
    sequence: number;
    type: string;
    account_id: string;
    color: string;
    icon: string;
    units: FixAssetLookupUnitModel[];


    /**
     * Constructor
     *
     * @param asset
     */
    constructor(asset?)
    {
        asset = asset || {};
        this.color = asset.color
        this.icon = asset.icon;
        this.id = asset.id;
        this.account_id = asset.account_id;
        this.name = asset.name;
        this.code = asset.code;
        this.sequence = asset.sequence;
        this.type = asset.type;
    }    
}
